import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api, type Pagina } from '../../lib/api'
import { chaves } from '../../lib/query'
import type { UsuarioAdmin } from '../../lib/tipos'

export function useUsuarios(busca: string, pagina: number) {
  return useQuery({
    queryKey: chaves.usuarios(busca, pagina),
    queryFn: () => api.obter<Pagina<UsuarioAdmin>>('/usuarios/', { busca, page: pagina }),
    placeholderData: (anterior) => anterior,
  })
}

/**
 * Criar e editar usuário no mesmo hook: sem `id` é POST, com `id` é PATCH.
 *
 * A senha viaja no `dados` só quando o formulário a preenche — em branco no modo
 * edição significa "mantém a atual", e o backend não a toca.
 */
export function useSalvarUsuario() {
  const cliente = useQueryClient()
  return useMutation({
    mutationFn: ({ id, dados }: { id?: number; dados: Record<string, unknown> }) =>
      id === undefined
        ? api.criar<UsuarioAdmin>('/usuarios/', dados)
        : api.atualizar<UsuarioAdmin>(`/usuarios/${id}/`, dados),
    onSuccess: () => {
      void cliente.invalidateQueries({ queryKey: ['usuarios'] })
    },
  })
}

/** Ativar/desativar — a ação de linha. Desativar preserva o histórico do usuário. */
export function useAlternarAtivo() {
  const cliente = useQueryClient()
  return useMutation({
    mutationFn: ({ id, isActive }: { id: number; isActive: boolean }) =>
      api.atualizar<UsuarioAdmin>(`/usuarios/${id}/`, { isActive }),
    onSuccess: () => {
      void cliente.invalidateQueries({ queryKey: ['usuarios'] })
    },
  })
}
